import React from "react";

export type CheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
  id?: string;
  className?: string;
  labelClassName?: string;
};

export default function Checkbox({
  checked,
  onChange,
  label,
  id,
  className = "",
  labelClassName = "",
}: CheckboxProps) {
  const generatedId = React.useId();
  const inputId = id || generatedId;

  return (
    <label
      htmlFor={inputId}
      className={["flex w-full cursor-pointer items-center gap-3 text-left select-none", className]
        .filter(Boolean)
        .join(" ")}
    >
      <input
        id={inputId}
        type="checkbox"
        checked={checked}
        onChange={(event) => onChange(event.target.checked)}
        className="sr-only"
      />
      <span
        className={[
          "inline-flex h-4 w-4 shrink-0 items-center justify-center rounded-[3px] border transition-colors",
          checked ? "border-brand-blue bg-bg-blue" : "border-light-grey bg-white",
        ].join(" ")}
      >
        {checked ? <span className="h-2 w-2 rounded-[1px] bg-brand-blue" /> : null}
      </span>
      <span className={["text-xs leading-5 text-dark-black", labelClassName].filter(Boolean).join(" ")}>
        {label}
      </span>
    </label>
  );
}
